import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MODEL_NAME_MAP } from '@core/constant';
import { FileService } from '@core/services/file-service';
import { PrivilegeService } from '@core/services/privilege.service';

import { CoreMenuItem, ReleaseNote } from '@core/types';
import { Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';

@Component({
	selector: '[core-menu-vertical-item]',
	templateUrl: './item.component.html'
})
export class CoreMenuVerticalItemComponent implements OnChanges {
	@Input() item: CoreMenuItem;
	@Output('viewCheckIn') public viewCheckIn: EventEmitter<any> = new EventEmitter<any>();

	// Public
	public firmwareRelease: Array<string> = [];

	// Private
	private _unsubscribeAll$: Subject<any>;

	/**
	 * Constructor
	 * 
	 * @param {FileService} _fileService
	 * @param {PrivilegeService} _privilegeService
	 */
	constructor(private _fileService: FileService,
		private _privilegeService: PrivilegeService
	) {
		this._unsubscribeAll$ = new Subject();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.item && this.item) {
			if (this.item.id === "FILEMANAGEMENT" && this._privilegeService.checkAccessByRole("FILEMANAGEMENT")) {
				this._fileService.currentNewFirmwareList
					.pipe(takeUntil(this._unsubscribeAll$), filter(x => x != null), take(1))
					.subscribe({
						next: (firmwareData) => {
							this.firmwareRelease = firmwareData.map(x => `- ${MODEL_NAME_MAP[x.modelKey]}`);
							this.viewCheckIn.emit();
						}
					});
			}
		}
	}

}
